import { defaultPaginationRoutePath } from '../../../constants/paginationConstant';
import { screenRoutes } from '../../../constants/routesPath';

export type HandlerType = () => void;
export type ViewType = 'grid' | 'list';

export const resetMediaLibraryPagination = ({ history }: any) => {
	history.push(`${screenRoutes.PUBLISH_ALL_MEDIA}${defaultPaginationRoutePath}`);
};
